import { render, staticRenderFns } from "./Fade.vue?vue&type=template&id=422c3b9f&scoped=true&"
import script from "./Fade.vue?vue&type=script&lang=ts&"
export * from "./Fade.vue?vue&type=script&lang=ts&"
import style0 from "./Fade.vue?vue&type=style&index=0&id=422c3b9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422c3b9f",
  null
  
)

export default component.exports